/* global axios */
import ApiClient from './ApiClient';

class OrdersAPI extends ApiClient {
  constructor() {
    super('orders', { accountScoped: true });
  }

 // get all orders item orders
  getAllOrders(params={}) {
    return axios.get(`${this.url}/index`,{
      params: {
        ...params
      }
    });
  }
  getAllOrderList(params={}) {
    return axios.get(`${this.url}/lists`,{
      params: {
        ...params
      }
    });
  }
  getOrderById(order_id) {
    return axios.get(`${this.url}/?id=${order_id}`);
  }
  createNewOrder(payloadBody) {
    return axios.post(`${this.url}/`,payloadBody);
  }
  // Update order by oder_id
  updateOrderById(order_id,payloadBody) {
    return axios.patch(`${this.url}/${order_id}`,payloadBody);
  }

  // get report by type
  getReportByType(type,start_date,end_date){
    return axios.get(`${this.url}/report?type=${type}&start_date=${start_date}&end_date=${end_date}`);
  }

  fetchUsagesOrderReport(queryObj={}){
    const params = new URLSearchParams(queryObj).toString();
    return axios.get(`${this.url}/transactions?${params}`);
  }

  refundAmount(order_id,payload){
    return axios.post(`${this.url}/${order_id}/refund_order`,payload);
  }

  fetchAvailableRefund(order_id){
    return axios.get(`${this.url}/${order_id}/fetch_available_refund`);
  }
  sendPaymentLink(order_id,params={}){
    return axios.get(`${this.url}/${order_id}/manual_payment_link`,{params});
  }

  fetch_available_delivery(payload){
    return axios.post(`${this.url}/fetch_available_delivery`,{...payload});
  }

}

export default new OrdersAPI();
